/* Guided Exposure — global scripts */
(function () {
  'use strict';

  /* Mobile nav toggle */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-site-nav]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  /* Site search toggle */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    var panel = document.querySelector('[data-search-panel]');
    if (!panel) return;
    var willOpen = panel.hasAttribute('hidden');
    if (willOpen) {
      panel.removeAttribute('hidden');
      var input = panel.querySelector('[data-search-input]');
      if (input) input.focus();
    } else {
      panel.setAttribute('hidden', '');
    }
    document.querySelectorAll('[data-search-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  /* Dropdown menus */
  document.addEventListener('click', function (e) {
    var dt = e.target.closest('[data-dropdown-toggle]');
    if (dt) {
      var item = dt.closest('[data-dropdown]');
      var href = dt.getAttribute('href');
      if (!href || href === '#' || window.matchMedia('(max-width: 900px)').matches) {
        e.preventDefault();
        var open = item.classList.toggle('is-open');
        dt.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    if (!e.target.closest('[data-dropdown]')) {
      document.querySelectorAll('[data-dropdown].is-open').forEach(function (d) {
        d.classList.remove('is-open');
        var t = d.querySelector('[data-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* Copy link (article share) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    var url = btn.getAttribute('data-url');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        btn.classList.add('copied');
        btn.setAttribute('aria-label', 'Link copied');
        setTimeout(function () { btn.classList.remove('copied'); btn.setAttribute('aria-label', 'Copy link'); }, 1600);
      });
    }
  });

  /* Accordions (FAQ, itinerary, etc.) */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion-item]');
    if (!item) return;
    var expanded = item.getAttribute('data-open') === 'true';
    item.setAttribute('data-open', expanded ? 'false' : 'true');
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });

  /* Sticky trip section-nav */
  var spy = document.querySelector('[data-section-nav]');
  if (spy) {
    var links = spy.querySelectorAll('a[href^="#"]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Jump in-page WITHOUT stacking browser history: replace (not push) the hash,
       so one Back returns to the previous page instead of unwinding each jump. */
    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var id = l.getAttribute('href').slice(1);
        var t = document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) { history.replaceState(null, '', '#' + id); }
      });
    });

    /* Scrollspy: highlight the section currently in view */
    if ('IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (l) {
        var id = l.getAttribute('href').slice(1);
        var t = document.getElementById(id);
        if (t) map[id] = l;
      });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            links.forEach(function (l) { l.removeAttribute('data-active'); });
            if (map[en.target.id]) map[en.target.id].setAttribute('data-active', 'true');
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      Object.keys(map).forEach(function (id) {
        var t = document.getElementById(id);
        if (t) obs.observe(t);
      });
    }
  }
})();
